import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RoleAwareLink from '../../../common/RoleAwareLink';
import Queue from '../../../queue/QueueContainer';
import { activeShop, isBrandViewActive } from '../../../auth/selectors';
import { getHasUnconfirmedBarbers } from '../selector';
import { canUseChairRental, canUserViewBarbers, canUserViewStaffManagement } from '../../../common/helpers/users';
import withPermissions from '../../../auth/utils/withPermissions';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../modules/infra/feature-flags';

const BarbersPageTabs = ({
  showUnconfirmedBarbersTab,
  showChairRentalTab,
  isChairRentalPage,
  showStaffManagementTab,
  showBarberTabs,
}) => (
  <div className="s-v2">
    <ul className="layout layout--small layout--auto u-mb- u-position-relative">
      <li className="layout__item">
        <RoleAwareLink
          to="/barbers"
          activeClassName="is-active"
          className="c-nav-tab"
          onlyActiveOnIndex
          display-if={showBarberTabs}
        >
          Confirmed
        </RoleAwareLink>
      </li>
      <li className="layout__item" display-if={showStaffManagementTab}>
        <RoleAwareLink onlyActiveOnIndex to="/staff" activeClassName="is-active" className="c-nav-tab">
          Staff
        </RoleAwareLink>
      </li>
      <li className="layout__item" display-if={showBarberTabs && showUnconfirmedBarbersTab}>
        <RoleAwareLink to="/barbers/unconfirmed" activeClassName="is-active" className="c-nav-tab">
          Unconfirmed
        </RoleAwareLink>
      </li>
      <li className="layout__item" display-if={showBarberTabs || showStaffManagementTab}>
        <RoleAwareLink to="/staff/deleted" activeClassName="is-active" className="c-nav-tab">
          Deleted
        </RoleAwareLink>
      </li>
      <li className="layout__item" display-if={showChairRentalTab}>
        <RoleAwareLink
          to={'/barbers/chair-rental'}
          activeClassName="is-active"
          className="c-nav-tab"
        >
          Rent Collect
        </RoleAwareLink>
      </li>
      <li className="layout__item u-pin-right u-pin-right-responsive u-mt-" display-if={isChairRentalPage}>
        <Queue
          btnClass="c-btn c-btn--medium"
          btnLabel="Export Payments"
          name="reports"
          jobName="booth-rental-payment-report"
          label="Export Rent Collect rental payments"
        />
      </li>
    </ul>
  </div>
);

BarbersPageTabs.propTypes = {
  showUnconfirmedBarbersTab: PropTypes.bool,
  showChairRentalTab: PropTypes.bool,
  isChairRentalPage: PropTypes.bool,
  showStaffManagementTab: PropTypes.bool,
  showBarberTabs: PropTypes.bool,
};

BarbersPageTabs.defaultProps = {
  showUnconfirmedBarbersTab: false,
  showChairRentalTab: false,
  isChairRentalPage: false,
  showStaffManagementTab: false,
  showBarberTabs: false,
};

export default compose(
  withRouter,
  withPermissions,
  withInjectFeatureFlagsToProps([flagNames.HYBRID_EXPOSE_RENT_COLLECT]),
  connect((state, ownProps) => {
    const isBrandView = isBrandViewActive(state);
    return {
      showBarberTabs: canUserViewBarbers(ownProps.permissions),
      showUnconfirmedBarbersTab: !isBrandView && getHasUnconfirmedBarbers(state),
      showChairRentalTab:
        !isBrandView && canUseChairRental(activeShop(state), ownProps[flagNames.HYBRID_EXPOSE_RENT_COLLECT]),
      isChairRentalPage: ownProps.location.pathname.includes('chair-rental'),
      showStaffManagementTab: canUserViewStaffManagement(state),
    };
  })
)(BarbersPageTabs);
